import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GeoPortaleComponent } from './geo-portale.component';
import { CommonModule } from '@angular/common';

export const COMPONENTS = [GeoPortaleComponent];

@NgModule({
  declarations: COMPONENTS,
  imports: [TranslateModule, CommonModule],
  exports: COMPONENTS,
})
export class GeoPortaleModule {}
